import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum QuoteTableColumn {
  QuoteNumber = 'quote_number',
  QuoteStatus = 'quote_status',
  QuoteTotal = 'quote_total',
  JobNumbers = 'job_numbers',
  JobType = 'job_type',
  Assets = 'asset',
  LocationName = 'location_name',
  ExpirationDt = 'expiration_dt',
  PoNumber = 'po_number',
  OrderNumber = 'order_number',
  RenewPickTicketNumber = 'renew_pick_ticket_number'
}

export function constructQuotesColumns(
  quoteNumberColumnTmp: TemplateRef<any>,
  assetColumnTmp: TemplateRef<any>,
  showCustomFields: boolean,
): TableColumn[] {
  let columns: TableColumn[] = [
    {
      columnId: QuoteTableColumn.QuoteNumber,
      header: 'Quote Number',
      type: TableColumnType.Template,
      template: quoteNumberColumnTmp,
      sortable: true,
    },
    {
      columnId: QuoteTableColumn.QuoteStatus,
      header: 'Status',
      type: TableColumnType.Tag,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.QuoteTotal,
      header: 'Quote Total',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.JobNumbers,
      header: 'Job Number(s)',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.JobType,
      header: 'Job Type',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.Assets,
      header: 'Asset(s)',
      type: TableColumnType.Template,
      template: assetColumnTmp,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.LocationName,
      header: 'Location',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.ExpirationDt,
      header: 'Expiration Date',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: QuoteTableColumn.PoNumber,
      header: 'Pick Tick. No.',
      type: TableColumnType.Text,
      sortable: false,
    },
    {
      columnId: QuoteTableColumn.OrderNumber,
      header: 'Order No.',
      type: TableColumnType.Text,
      sortable: false,
    },
    {
      columnId: QuoteTableColumn.RenewPickTicketNumber,
      header: 'Renew Pick Ticket No.',
      type: TableColumnType.Text,
      sortable: false,
    }
  ];

  if (!showCustomFields) {
    columns = columns.filter(col => col.columnId !== QuoteTableColumn.PoNumber);
  }
  return columns;
}
